"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFormsTemplateCategory_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var EFormsTemplateDetail_1 = require("./EFormsTemplateDetail");
var EFormsTemplateCategory_Factory = /** @class */ (function () {
    function EFormsTemplateCategory_Factory() {
    }
    EFormsTemplateCategory_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateDetails: model.TemplateDetails && model.TemplateDetails.map(function (i) { return EFormsTemplateDetail_1.EFormsTemplateDetail_Factory.CreateIncoming(i); }),
        };
        return result;
    };
    EFormsTemplateCategory_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Name: model.Name,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordLastUpdated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordLastUpdated),
            RecordStatus: model.RecordStatus,
            TemplateDetails: model.TemplateDetails && model.TemplateDetails.map(function (i) { return EFormsTemplateDetail_1.EFormsTemplateDetail_Factory.CreateOutgoing(i); }),
        };
        return result;
    };
    return EFormsTemplateCategory_Factory;
}());
exports.EFormsTemplateCategory_Factory = EFormsTemplateCategory_Factory;
